<template>
  <div class="scroll-con" style="margin-top: 10px">
    <div class="table-title">实时播报</div>
    <dv-scroll-board
      :config="config"
      style="width: 510px; height: 150px; margin-top: 10px"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import pollingFunction from "@/utils/tools";
export default {
  computed: {
    ...mapState(["boardData"]),
  },
  data() {
    return {
      config: {
        data: [],
        columnWidth: [20, 100, 80],
        align: ["center"],
        carousel: "page",
        oddRowBGC: "rgba(0,0,0,0)",
        evenRowBGC: "rgba(0,0,0,0)",
        waitTime: 0,
        rowNum: 5,
        headerHeight: 20,
      },
    };
  },
  async mounted() {
    //调用轮询;
    if (!this.pollingST) {
      setTimeout(() => {
        this.pollingST = pollingFunction(this.getData, 3000);
      }, 3000);
    }
    await this.getData();
  },
  methods: {
    ...mapActions(["getBoardData"]),
    async getData() {
      await this.getBoardData({});
      let data_arr = this.boardData.map((item) => {
        let arr = [];
        arr[0] = "<span class='dot'></span>";
        arr[1] = item.datetime ? item.datetime.substring(5, 16) : "-";
        arr[2] = item.eventType;
        arr[3] = item.event;
        return arr;
      });

      this.config = {
        data: data_arr,
        columnWidth: [20, 100, 80],
        align: ["center"],
        carousel: "page",
        oddRowBGC: "rgba(0,0,0,0)",
        evenRowBGC: "rgba(0,0,0,0)",
        waitTime: 9999999999999,
        rowNum: 5,
        headerHeight: 20,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.scroll-con {
}
.table-title {
  width: 189px;
  height: 40px;
  line-height: 40px;
  background: url("../../assets/index/table-title-bg.png") no-repeat center;
  background-size: contain;
  color: #fff;
  text-align: center;
  font-size: 23px;
  font-weight: normal;
  font-family: Microsoft YaHei, Arial, "sans-serif";
}
</style>
<style>
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: rgba(20, 255, 255, 0.6);
  vertical-align: middle;
  color: rgba(20, 255, 255, 1);
  border-radius: 50%;
}
</style>
